module.exports = __webpack_public_path__ + "fonts/immrtlt_.3d510be5.ttf";